import { useTranslation } from 'react-i18next'

export default function StatsBar() {
  const { t } = useTranslation()

  const stats = [
    { value: t('landing.stats.docsVal'), label: t('landing.stats.docs') },
    { value: t('landing.stats.usersVal'), label: t('landing.stats.users') },
    { value: t('landing.stats.limitVal'), label: t('landing.stats.limit') },
  ]

  return (
    <section className="py-10 bg-white dark:bg-gray-900 border-y border-gray-100 dark:border-gray-700">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
          {stats.map((stat) => (
            <div key={stat.label}>
              <div
                className="text-3xl font-bold text-gray-900 dark:text-white mb-1"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {stat.value}
              </div>
              <div
                className="text-sm text-gray-500 dark:text-gray-400"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
